import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
  SidebarSubmenu,
  SidebarSubmenuItem,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import HomeIcon from '@material-ui/icons/Home';
import CategoryIcon from '@material-ui/icons/Category';
import AndroidIcon from '@material-ui/icons/Android';
import MapIcon from '@material-ui/icons/MyLocation';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import CreateComponentIcon from '@material-ui/icons/AddCircleOutline';
import BuildIcon from '@material-ui/icons/BuildOutlined';
import AnnouncementIcon from '@material-ui/icons/AnnouncementOutlined';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import SchoolIcon from '@material-ui/icons/School';
import { SidebarSearchModal } from '@backstage/plugin-search';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import { useApp } from '@backstage/core-plugin-api';
import { FeatureFlagged } from '@backstage/core-app-api';
import { AiDataMaintenanceSidebar } from '@internal/backstage-plugin-ai-data-maintenance';
import { DashboardSidebarItem } from 'backstage-plugin-dashboard/src/components/DashboardSidebarItem/DashboardSidebarItem';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const app = useApp();

      // Skipped items
      nav.take('page:search'); // Using search modal instead

      return (
          <Sidebar>
            <SidebarLogo />
            <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
              <SidebarSearchModal />
            </SidebarGroup>

            <FeatureFlagged with="ai-agent-data-maintenance">
              <AiDataMaintenanceSidebar />
            </FeatureFlagged>

            <SidebarItem
              target="_blank"
              to="https://chat.prod.ki-plattform.exxcellent.de/"
              title="Chat"
              icon={AndroidIcon}
              text="Chat"
            />

            <SidebarDivider />
            <SidebarGroup label="Menu" icon={<MenuIcon />}>
              <SidebarItem icon={HomeIcon} to="/" text="Home" />

              <SidebarItem icon={CategoryIcon} to="catalog" text="Catalog">
                <SidebarSubmenu title="Catalog">
                  <SidebarSubmenuItem
                    title="Sectors"
                    to="catalog?filters[kind]=domain&filters[namespace]=sectors"
                    icon={app.getSystemIcon('kind:domain')}
                  />
                  <SidebarSubmenuItem
                    title="Customers"
                    to="catalog?filters[kind]=domain&filters[namespace]=default"
                    icon={app.getSystemIcon('kind:domain')}
                  />
                  <SidebarSubmenuItem
                    title="Projects"
                    to="catalog?filters[kind]=system"
                    icon={app.getSystemIcon('kind:system')}
                  />
                  <SidebarSubmenuItem
                    title="Project components"
                    to="catalog?filters[kind]=component&filters[type]=project"
                    icon={app.getSystemIcon('kind:component')}
                  />
                  <SidebarSubmenuItem
                    title="Technical components"
                    to="catalog?filters[kind]=component&filters[type]=language&filters[type]=library&filters[type]=technique"
                    icon={app.getSystemIcon('kind:component')}
                  />
                  <SidebarSubmenuItem
                    title="APIs"
                    to="catalog?filters[kind]=api"
                    icon={app.getSystemIcon('kind:api')}
                  />
                  <SidebarDivider />
                  <SidebarSubmenuItem
                    title="Resources"
                    to="catalog?filters[kind]=resource"
                    icon={app.getSystemIcon('kind:resource')}
                  />
                  <SidebarDivider />
                  <SidebarSubmenuItem
                    title="Groups"
                    to="catalog?filters[kind]=group"
                    icon={app.getSystemIcon('kind:group')}
                  />
                  <SidebarSubmenuItem
                    title="Users"
                    to="catalog?filters[kind]=user"
                    icon={app.getSystemIcon('kind:user')}
                  />
                </SidebarSubmenu>
              </SidebarItem>

              <FeatureFlagged with="dashboard-enable">
                <DashboardSidebarItem />
              </FeatureFlagged>

              <SidebarItem icon={LibraryBooks} to="docs" text="Docs" />
              <SidebarItem
                icon={CreateComponentIcon}
                to="create"
                text="Create..."
              />
              <SidebarDivider />
              <SidebarScrollWrapper>
                <SidebarItem icon={MapIcon} to="tech-radar" text="Tech Radar" />
                <SidebarItem
                  icon={SchoolIcon}
                  to="skill-exchange"
                  text="Skill Exchange"
                />
                <FeatureFlagged with="skill-hub-enable">
                  <SidebarItem
                    icon={SchoolIcon}
                    to="/skill-hub"
                    text="Skill Hub"
                  />
                </FeatureFlagged>
              </SidebarScrollWrapper>
            </SidebarGroup>
            <SidebarSpace />
            <SidebarDivider />
            <SidebarGroup
              label="Settings"
              icon={<UserSettingsSignInAvatar />}
              to="/settings"
            >
              <SidebarItem
                icon={BuildIcon}
                to="entity-validation"
                text="Validator"
              />
              <NotificationsSidebarItem />
              <SidebarItem
                icon={AnnouncementIcon}
                to="/announcements"
                text="Announcements"
              />
              <SidebarSettings />
            </SidebarGroup>
          </Sidebar>
      );
    },
  },
});
